"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { Drawer } from "@base-ui/react/drawer";
import { Popover } from "@base-ui/react/popover";
import { forwardRef, useMemo, useState } from "react";
import { PortalContainerProvider } from "../../contexts/index.js";
import { cn } from "../../utils/cn.js";
import { DRAWER_SWIPE_IGNORE_ATTRIBUTE } from "../../utils/constants.js";
import { mergeRefs } from "../../utils/mergeRefs.js";
import { DrawerHandle } from "../Drawer/DrawerHandle.js";
import { popoverVariants } from "./Popover.variants.js";
import { usePopoverMode } from "./PopoverContext.js";
const PopoverPopup_PopoverPopup = /*#__PURE__*/ forwardRef(function({ className, size, scroll, stickyFooter, customHeader, customFooter, customBody, noHeading, slots, ...props }, ref) {
    const mode = usePopoverMode();
    const { popup, popupAnimation, drawerPopup, viewport } = popoverVariants({
        size,
        scroll,
        stickyFooter,
        customHeader,
        customFooter,
        customBody,
        noHeading
    });
    const [container, setContainer] = useState(null);
    const mergedRef = useMemo(()=>mergeRefs(ref, setContainer), [
        ref
    ]);
    if ('drawer' === mode) {
        const drawerPopupClasses = cn(drawerPopup(), className, slots?.popup);
        const { children, ...drawerProps } = props;
        return /*#__PURE__*/ jsx(Drawer.Viewport, {
            className: cn(viewport(), slots?.viewport),
            children: /*#__PURE__*/ jsxs(Drawer.Popup, {
                ref: mergedRef,
                "data-mode": "drawer",
                className: drawerPopupClasses,
                ...drawerProps,
                children: [
                    /*#__PURE__*/ jsx(DrawerHandle, {}),
                    /*#__PURE__*/ jsx(PortalContainerProvider, {
                        container: container,
                        children: children
                    })
                ]
            })
        });
    }
    const popupClasses = cn(popup(), popupAnimation(), className, slots?.popup);
    const { children, ...popoverProps } = props;
    return /*#__PURE__*/ jsx(Popover.Popup, {
        ref: mergedRef,
        "data-mode": "popover",
        [DRAWER_SWIPE_IGNORE_ATTRIBUTE]: '',
        className: popupClasses,
        ...popoverProps,
        children: /*#__PURE__*/ jsx(PortalContainerProvider, {
            container: container,
            children: children
        })
    });
});
export { PopoverPopup_PopoverPopup as PopoverPopup };
